module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_M4-73badabd82821ea8f5c463f1cc89b06e.png";